import React, {useEffect, useState} from "react";
import styled from "styled-components";
import { Ring } from "@uiball/loaders";
import PlayIcon from "../../../../resources/play.png"
import useI18n from "@appsinti/i18n/useI18n";
import { useData } from "../../../data";
import { useImagePreload } from "../../../../hooks/useImagePreload";
import { attemptRecovery } from "../../../../utils/recovery";

// All thumbnails share this gate: a single areas refetch renews the signed
// URLs of every camera at once, so one attempt per cooldown window is enough.
const AREAS_REFETCH_RECOVERY_KEY = "bigbrother:areas-refetch";

const Image = styled.div<{ src: string }>`
  width: 90vw;
  height: 45vw;
  background-image: url(${({src}) => src});
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Tile = styled.div`
  width: 90vw;
  height: 45vw;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: center;
`

const PlaceholderTile = styled(Tile)`
  background-color: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
`

const Preview: React.FC<{ url: string, onClick: any }> = ({url, onClick}) => {
    const [updatedUrl, setUrl] = useState<string>(url);
    const { lastUpdate, fetchData } = useData();
    const { translateObject } = useI18n();
    const { status, lastLoadedUrl } = useImagePreload(updatedUrl);

    useEffect(() => {
      try {
        const u = new URL(url);
        u.searchParams.set("t", String(Date.now()));
        setUrl(u.toString());
      } catch {
        const hasQuery = url.includes("?");
        setUrl(`${url}${hasQuery ? "&" : "?"}t=${Date.now()}`);
      }
    }, [url, lastUpdate]);

    // A failed thumbnail may just carry an expired signature (12h TTL on a
    // long-lived tab): refetch the areas so fresh signed URLs can heal it.
    useEffect(() => {
      if (status !== 'failed') return;
      if (!attemptRecovery(AREAS_REFETCH_RECOVERY_KEY)) return;
      fetchData();
    }, [status, fetchData]);

    const displayUrl = status === 'loaded' ? updatedUrl : lastLoadedUrl;

    if (displayUrl) {
      return (
        <Image src={displayUrl} onClick={onClick}>
            <img src={PlayIcon} alt="play" style={{width: '50px', height: '50px', zIndex: 10}}/>
        </Image>
      )
    }

    if (status === 'loading') {
      return (
        <Tile onClick={onClick}>
          <Ring color={"white"} size={30} />
        </Tile>
      )
    }

    return (
      <PlaceholderTile onClick={onClick}>
        <img src={PlayIcon} alt="play" style={{width: '50px', height: '50px', zIndex: 10}}/>
        <span>{translateObject({ en: "No preview", es: "Sin vista previa" })}</span>
      </PlaceholderTile>
    )
}

export default Preview
